<template>
  <div class="tabs-component" :class="{'box':look=='boxed'}" :data-look="look">
    <div :class="{'header':look=='boxed'}">
      <div class="tab-links">
        <div class="tab-link" :class="{'active':tab.isActive}" v-for="(tab,i) in tabs" @click="selectTab(i)" v-html="tab.header"></div>
      </div>
    </div>
    <div :class="{'content':look=='boxed'}">
      <div class="tab-area" :data-look="look">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: [ 'active-tab', 'look' ],
        data: () => ({
            tabs: [],
            //activeTabHash: '',
        }),
        computed: {

        },
        created() {
            this.tabs = this.$children;
        },
        mounted() {
            //window.addEventListener('hashchange', () => this.selectTab(window.location.hash));

            //if (this.findTab(window.location.hash)) {
            //    this.selectTab(window.location.hash);
            //    return;
            //}

            //const previousSelectedTabHash = expiringStorage.get(this.storageKey);

            //if (this.findTab(previousSelectedTabHash)) {
            //    this.selectTab(previousSelectedTabHash);
            //    return;
            //}

            //if (this.tabs.length) {
            //    this.selectTab(this.tabs[0].hash);
            //}
        },

        methods: {
            findTab(hash) {
                return this.tabs.find(tab => tab.hash === hash);
            },

            selectTab(index) {

                var i = 0
                this.tabs.forEach(tab => {
                    tab.isActive = i == index
                    i++
                })

                this.$emit('changed', { tab: selectedTab });


                return
                const selectedTab = this.findTab(selectedTabHash);

                if (! selectedTab) {
                    return;
                }

                this.tabs.forEach(tab => {
                    tab.isActive = (tab.hash === selectedTab.hash);
                });

                this.$emit('changed', { tab: selectedTab });

                this.activeTabHash = selectedTab.hash;

                //expiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLifetime);
            },
        },
    };
</script>

<style lang="scss">
	@import '../styling/global_vars';
  .tab-links {

  }
  .box .content .tab-links .tab-link {
    display: inline-block;
    cursor: pointer;
    background-color: yellow;
    padding: 1em;
    opacity: .5;
    &.active {
      opacity: 1;
    }
  }
  .tab-area.not-boxed {
    border: 2px solid green;
    padding: 1em;
  }
  .tab-links {

  }

  .tab-links[data-look="boxed"] .tab-link {
    display: inline-block;
    cursor: pointer;
    //background-color: yellow;
    padding: 1em;
    opacity: .5;
    &.active {
      opacity: 1;
      background-color: $skin1_color3;
      color: $skin1_color4;
    }
  }
</style>



// WEBPACK FOOTER //
// Tabs.vue?633afafc